import React from 'react';

import { FactorType } from 'common/api/endpoints/roadmaps';
import {
  CustomDescriptionFieldTypes,
  DefaultDescriptionFieldTypes,
} from 'common/prioritization/DescriptionColumnTypes';

import DateRangeFilter from './DateRangeFilter';
import SelectFilter from './SelectFilter';
import TextFilter from './TextFilter';

import type { Board } from 'common/api/endpoints/boards';
import type { Board as PlainBoard } from 'common/api/resources/board';

type Props = {
  boards: Board[];
  distinctBoards: PlainBoard[];
  fieldID: string | null;
  id: string;
  isCustomDescriptionColumn: boolean;
  name: string;
  options?: string[];
  type?: CustomDescriptionFieldTypes | DefaultDescriptionFieldTypes | keyof typeof FactorType;
};

const isNumericType = (type: string) => {
  return (
    type === CustomDescriptionFieldTypes.integer ||
    type === FactorType.numberToTen ||
    type === FactorType.numberToOneHundred ||
    type === FactorType.percentage ||
    type === FactorType.calculation ||
    type === FactorType.fibonacci ||
    type === FactorType.stars
  );
};

const FilterWrapper = ({
  boards,
  distinctBoards,
  fieldID,
  id,
  isCustomDescriptionColumn,
  name,
  options,
  type,
}: Props) => {
  if (type === DefaultDescriptionFieldTypes.dateRange) {
    return (
      <li key={`${id}_filter`}>
        <DateRangeFilter name={name} />
      </li>
    );
  }

  if (
    type === DefaultDescriptionFieldTypes.multiSelect ||
    type === DefaultDescriptionFieldTypes.singleSelect ||
    type === CustomDescriptionFieldTypes.multiselect ||
    type === CustomDescriptionFieldTypes.dropdown ||
    type === FactorType.checkbox
  ) {
    return (
      <li key={`${id}_filter`}>
        <SelectFilter
          boards={boards}
          distinctBoards={distinctBoards}
          fieldID={fieldID}
          isCustomDescriptionColumn={isCustomDescriptionColumn}
          name={name}
          options={options}
          type={type}
        />
      </li>
    );
  }

  if (
    type &&
    (type === CustomDescriptionFieldTypes.text ||
      type === CustomDescriptionFieldTypes.multilineText ||
      isNumericType(type)) &&
    fieldID
  ) {
    return (
      <li key={`${id}_filter`}>
        <TextFilter
          fieldID={fieldID}
          isCustomDescriptionColumn={isCustomDescriptionColumn}
          inputType={isNumericType(type) ? 'number' : 'text'}
        />
      </li>
    );
  }

  return null;
};

export default FilterWrapper;
